import React from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";

const TermsContentSection = styled.div`
  padding: 20px 0;
  @media screen and (max-width: 1700px) {
    padding: 10px 0;
  }
  @media screen and (max-width: 1400px) {
    padding: 10px 0;
  }
  @media screen and (max-width: 1200px) {
    padding: 0;
  }
  @media screen and (max-width: 992px) {
    padding: 0;
  }
  h2 {
    font-size: 24px;
    color: #4d4d4d;
    margin: 0;
    padding-bottom: 20px;
    @media screen and (max-width: 1700px) {
      padding-bottom: 10px;
    }
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #4d4d4d;
    text-align: justify;
    @media screen and (max-width: 1400px) {
      padding-bottom: 10px;
    }
  }
  ul {
    list-style: circle;
    li {
      padding-bottom: 10px;
    }
  }
`;

const TermsContent = () => {
  return (
    <>
      <Container className="mt-30 mb-30">
        <TermsContentSection>
          <p>
            Vuezen is a brand of Luxelace Luxury Private Limited a Company
            Incorporated under the Companies Act, 2013 having Corporate
            Identification Number: U14109UP2023PTC190197 (hereinafter referred
            to as ‘Company’) and having its registered office at A-63, Sector 4,
            Noida Uttar Pradesh 201301.{" "}
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>1. Policy for NDNC</h2>
          <p>
            By using the website and/or registering yourself at Vuezen.com you
            authorize us to contact you via email or phone call or sms and offer
            you our services, imparting product knowledge, offer promotional
            offers running on website & offers offered by the associated third
            parties, for which reasons, personally identifiable information may
            be collected. And irrespective of the fact if also you have
            registered yourself under DND or DNC or NCPR service, you still
            authorize us to give you a call from the Vuezen for the above
            mentioned purposes till 45 days of your registration with us. This
            Privacy Policy covers Vuezen’s treatment of personally identifiable
            information that Vuezen collects when you are on the Vuezen site,
            and when you use Vuezen’s services. This policy also covers Vuezen’s
            treatment of any personally identifiable information that Vuezen’s
            business partners share with Vuezen. This policy does not apply to
            the practices of companies that Vuezen does not own or control or to
            people that Vuezen does not employ or manage. Vuezen collects
            personally identifiable information when you register for a Vuezen
            account, when you use certain Vuezen products or services, when you
            visit Vuezen pages, and when you enter promotions. Vuezen may also
            receive personally identifiable information from our business
            partners. When you register with Vuezen, we ask for your first name,
            last name, contact no, email, Date of birth and gender. Once you
            register with Vuezen and sign in to our services, you are not
            anonymous to us. Also during registration, you may be requested to
            register your mobile phone and email id, pager, or other device to
            receive text messages, notifications, and other services to your
            wireless device. By registration you authorize us to send sms/email
            alerts to you for your login details and any other service
            requirements or some advertising messages/emails from us.
          </p>
          <p>
            If you do not agree to these terms and conditions, terms and
            conditions attached to any sale, purchase, warranty, use of our
            website and/ or our mobile application, then the purchase of any
            products or services through the website and / or the mobile
            application is prohibited. Continued use and access of the website,
            mobile application, any purchases and the services shall be deemed
            as the acceptance of our terms and conditions, policies and their
            potential changes.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>2.ACCEPTANCE OF TERMS OF USE</h2>
          <p>
            PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY. BY ACCESSING THIS
            WEBSITE YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS BELOW. THE
            COMPANY RESERVES THE RIGHT TO ALTER, AMEND AND MODIFY THESE TERMS
            AND CONDITIONS AT ITS SOLE DISCRETION. ALL SUCH AMENDMENTS AND
            MODIFICATIONS WILL BE DULY NOTIFIED ON THIS WEBSITE. IF YOU ARE NOT
            AGREEABLE TO THE TERMS AND CONDITIONS WE REQUEST YOU NOT TO ACCESS
            THIS WEBSITE. You expressly agree to be bound by this Agreement,
            irrespective of whether You are a registered member or a visitor, by
            using the information, tools, features and functionality located on
            this Website. As such, You agree to be bound by the terms and
            conditions detailed herein. The Company recommends that,
            irrespective of whether You are a Visitor or a Registered Member who
            proposes to utilize the Service provided by the Company, to
            carefully read all the terms and conditions as provided herein. The
            said terms and conditions displayed are recommended to be saved for
            any future reference and for Your own records or You may even take a
            print out of the same. The Company expressly states that the
            Services provided or offered by this Website and the Agreement which
            You are required to be bound by is meant only for
            individuals/entities who are permitted to enter into and be bound by
            a legal contract as per the prevalent laws. In the event, if You are
            not legally permitted to enter into a contract or are for some
            reason either due to Your age or any other reason not permitted to
            enter into an Agreement, then, You are not permitted to utilize the
            Services provided by this Website or enter into this Agreement. In
            the alternative You could order Products under parental supervision.
            Your acceptance of this Agreement and utilization of Services
            implies and You expressly and implicitly represent to the Company
            that You are of the legal contracting age or operating under
            parental supervision and nothing will invalidate this Agreement. The
            Company has the right to bind You and your parents to this
            Agreement. In the event that You are representing certain
            individual/s, company/ies, third parties or any entities, in any
            capacity, then, You expressly confirm that You have the valid
            authority and the right to do so for and on behalf of them. By
            entering into this Agreement, You state that You have the right to
            bind such individual/s, company/ies, third parties or any entities
            to this Agreement. The Services made available on or through this
            Website has been made available to You for the specific purpose of
            enabling Users to purchase original merchandise such as eyewear
            (which includes both spectacles and contact lens), watches and bags
            from various high end brands (collectively, "Products"). It is not
            intended to be providing You with any nature of certification,
            guarantee or warranty or any professional advice and is a mere
            information and guidance. By accessing, browsing and using this
            Website/s, You agree and acknowledge that You understand this
            limited and restricted use, and agree that You will not rely on the
            information and materials contained in this Website for any purposes
            except as is intended. You further agree that in all actual matters,
            You are ultimately responsible for determining Your specific
            requirements. You are strictly prohibited from unauthorized use of
            our systems or this Website/s, including but not limited to
            unauthorized entry into our systems, misuse of passwords, or misuse
            of any information posted to this Website. You acknowledge that the
            Company may disclose and transfer any information that You provide
            through this Website to (i) our affiliate or information providers,
            (ii) to any third party but strictly with Your permission, or (iii)
            if we are legally bound to disclose any information due to
            compulsions under law. You consent to the transmission, transfer or
            processing of such information to, or through, any country in the
            world, as we deem necessary or appropriate, and by using and
            providing information through this Website You agree to such
            transfers. You expressly agree and acknowledge that usage of the
            Website/s may be monitored, tracked and recorded. As such, You
            expressly consent to such monitoring, tracking and recording. You
            are responsible for being familiar with the current version of these
            Terms and Conditions posted on the Website during each session. By
            the continued accessing of this Website or the Services, You
            implicitly agree to be bound by the revised terms and conditions.
            Any such revisions will be duly posted on this Website and the
            Company may, if it chooses, send you an e-mail in this regard.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>3. General Terms and Conditions</h2>
          <p>
            <ul>
              <li>
                Returns and exchange of the products will be done within 14 days
                from the date of delivery.
              </li>
              <li>
                By choosing to go for this offer, the customer hereby confirms
                that he/she has studied these detailed Terms and Conditions and
                agrees to be bound by the same.
              </li>
              <li>
                Every person who desires to avail this offer may do so pursuant
                to independent inquiry, investigation and analysis and shall not
                have any claim against Vuezen, its employees, directors,
                representatives or affiliates whatsoever by reason of any loss
                which may be suffered by such person consequent to or in
                connection with the sale, whether by reason of anything stated
                or omitted to be stated herein.
              </li>
              <li>
                Vuezen reserves the right to amend or modify these terms
                (including price) without giving any kind of prior intimation.
              </li>
              <li>
                These T&C’s are governed under the laws of India. All disputes
                will be settled in the exclusive jurisdiction of the courts of
                New Delhi.
              </li>
              <li>
                The product images shown under this offer are for illustration
                purposes only and may not be an exact representation of the
                product
              </li>
              <li>
                The Company reserves the right to change the product images and
                specifications at any time without any prior notice
              </li>
              <li>
                For more information or queries, get in touch here 7.
                support@Vuezen.com. *In additions of these the terms of use on
                the Vuezen’s website shall also be applicable.
              </li>
            </ul>
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>4. T&C FOR Cash and Cash+</h2>
          <p>
            Vuezen Cash terms
            <ul>
              <li>
                - These are the general terms applicable to the discount
                provided under Vuezen Cash and the specific terms of any offer
                will be mentioned under products listings/ will be shared
                separately and will form part of these terms.
              </li>
              <li>
                - Vuezen cash redemption will always be limited to a certain
                amount/percentage of total order which will be defined under the
                product listings and will form part of these terms.
              </li>
              <li>- Valid once per user during the offer period.</li>
            </ul>
          </p>
          <p>
            Vuezen Cash +<p>Gold Max Membership Discount</p>
            <ul>
              <li>
                - Being Gold Max member or having Gold Max Membership in cart is
                essential to avail offer by any Customer.
              </li>
              <li>
                - 10% Vuezen cash+ on 1st purchase and 5% Vuezen cash+ on
                subsequent purchase until the validity of Gold Membership will
                be available to the Customer.
              </li>
              <li>
                - Purchase amount means total paid amount by the Customer.
              </li>
              <li>
                - VUEZEN cash+ validity is 364 days or expiry of Gold Membership
                whichever is earlier.
              </li>
              <li>
                - VUEZEN cash+ redemption is available up to a maximum limit of
                INR 20,000. We reserve the right, at any time, without prior
                notice and without assigning any reason whatsoever, to
                add/alter/modify/change or vary these terms and conditions or to
                replace, wholly or in part, this offer by another offer, whether
                similar to this offer or not, or to extend or withdraw it
                altogether.
              </li>
            </ul>
          </p>

          <p>
            Any other offers apart from Gold Max Membership
            <ul>
              <li>
                - VUEZEN cash+ redemption is available up to a maximum limit of
                INR 20,000. Valid once per user during the offer period.
              </li>
              <li>
                - Any promotional discount offered in the form of Vuezen Cash +
                will have different expiry and will differ on case to case
                basis.
              </li>
              <li>
                - These are the general terms applicable to the discount
                provided under Vuezen Cash + and the specific terms of any offer
                will be mentioned under products listings/ will be shared
                separately via Whatsapp messages, emails or any other medium of
                communication and the same will form part of these terms.
              </li>
            </ul>
          </p>

          <p>
            Product eligible for the discount/ offer under for VUEZEN Cash and
            VUEZEN Cash+
            <ul>
              <li>
                - Offer is applicable on select products across select
                categories on the platform.
              </li>
              <li>
                - Offer will also be listed on the product page, please check
                before making the purchase.
              </li>
            </ul>
          </p>

          <p>
            Other key offer terms for VUEZEN Cash and VUEZEN Cash+
            <ul>
              <li>
                - If an order is cancelled, the offer may be made available to
                customer for utilization again in our sole discretion.
              </li>
              <li>
                - The amount represented in the wallet and / or as Vuezen Cash/
                Cash+ under no circumstances should be considered as money or
                money equivalent. It is strictly in the nature of a discount
                provided to you on our products.
              </li>
              <li>
                - You cannot withdraw any amounts/ Vuezen Cash/ Cash+ from your
                wallet and you do not have ownership rights on these discounts.
              </li>
              <li>
                - Any Vuezen Cash/ Cash+ balance is a discount eligibility
                digital voucher which can be utilized to avail discounted
                products in the manner noted herein. Unless specifically
                mentioned otherwise, the amount in your wallet as balance/
                Vuezen Cash/ Cash+ is to be solely and strictly utilized as a
                discount against products on priority as against any other
                utilization that may be permitted by the Company.
              </li>
              <li>
                - In this regard “Discounts” shall include any bonus, cashback,
                extra cash or any other incentives that may be provided by the
                Company, at its discretion, as a part of pricing strategy as an
                adjustment against the price charged from the user in such
                manner as may be prescribed under these terms (as may be
                applicable)
              </li>
            </ul>
          </p>

          <p>
            VUEZEN Cash and VUEZEN Cash + Discount Redemption Process
            <ul>
              <li>- Login to Vuezen.com (Mobile App/Mobile Site/Website).</li>
              <li>- Add eligible products to the cart.</li>
              <li>- Proceed to checkout.</li>
              <li>
                - Apply the Vuezen Cash/ Cash+ on payments page in case you have
                such discount. In case there is no Vuezen Cash/ Cash+ offer
                available with you, the whole amount will be required to be paid
                as noted below.
              </li>
              <li>
                - Vuezen Cash / Cash + is in the nature of a ‘discount’ on the
                purchase of eligible product, remaining amounts can be paid by
                preferred method by the user.
              </li>
              <li>- Complete your transaction using options provided.</li>
              <li>
                - Users will be able to view the discount amount eligible on the
                payments page during checkout.
              </li>
              <li>- Offline purchases</li>
              <li>
                - At the store/ offline purchases, the coupon code can be
                applied on the eligible products while billing and checking out.
              </li>
            </ul>
          </p>

          <p>
            Where should I contact in case I didn't receive the cashback after
            an eligible purchase?
            <ul>
              <li>
                If you are eligible Vuezen Cash/ Cash+ offer as per the order
                summary page and you do not receive the same, please contact
                Vuezen customer care from the help section on Vuezen application
                and / or website.
              </li>
            </ul>
          </p>

          <p>
            VUEZEN Cash and VUEZEN Cash+ eligible users
            <ul>
              <li>
                The offer is open to all residents of India holding a valid and
                active Vuezen account.
              </li>
            </ul>
          </p>

          <p>
            Other terms, conditions and policies of Vuezen apply to the offer/
            VUEZEN Cash / VUEZEN Cash +
            <ul>
              <li>
                - By participating in the offer on any eligible sale for Cash/
                Cash+, Customers agree to be bound by:
              </li>
              <li>- These terms and conditions (T&C);</li>
              <li>
                - The terms of use, privacy policy and other relevant
                documentation including any modifications, alterations or
                updates thereof, that are published on the platform, website and
                our application;
              </li>
              <li>- Warranty terms and conditions;</li>
              <li>- All applicable terms and conditions of Vuezen; and</li>
              <li>
                - Offer specific details/ terms and conditions.
                <span>This offer is also subject to following conditions:</span>
              </li>
              <li>
                - This offer is only applicable on transactions made through
                payment options made available on our website/ stores.
              </li>
              <li>
                - In case of cancellation of your order, the transaction will
                not qualify for the offer.
              </li>
              <li>
                - Vuezen reserves the right to disqualify the user(s) from the
                benefits of the offer, if any fraudulent activity is identified
                as being carried out for availing the benefits under the said
                offer or otherwise by use of the account.
              </li>
              <li>
                - Any person availing this offer shall be deemed to have
                accepted these terms and conditions.
              </li>
              <li>
                - Vuezen reserves the right, at any time, without prior notice
                and without assigning any reason whatsoever, to
                add/alter/modify/change or vary these terms and conditions or to
                replace, wholly or in part, this offer by another offer, whether
                similar to this offer or not, or to extend or withdraw it
                altogether.
              </li>
              <li>
                - Users are not bound in any way to participate in this offer.
                Any participation is voluntary, and the offer is being made
                purely on a best effort basis.
              </li>
              <li>
                - Nothing herein amounts to a commitment by Vuezen to conduct
                further, similar or other offers.
              </li>
              <li>
                - The above offer is by way of a special offer for Vuezen
                registered users only and nothing contained herein shall
                prejudice or affect the terms and conditions of the Vuezen terms
                and conditions of use and privacy policy. The terms of the above
                schemes offer(s), shall be in addition to and not in derogation
                of the terms contained in the Vuezen terms and conditions of use
                and privacy policy.
              </li>
              <li>
                - You, the user, understands that Vuezen may use your
                transactional data for purposes of this offer and for checking
                your eligibility for their products and services and by
                participating in this offer, you consent to this sharing and
                using of your data for these purposes
              </li>
              <li>
                - Under no circumstance will the offer/cashback being offered be
                settled with cash in lieu by Vuezen
              </li>
              <li>
                - Returned transactions, disputed or unauthorized/ fraudulent
                transactions will not be considered for the offer.
              </li>
              <li>
                - This offer cannot be combined with other offers including any
                other discount / coupon code.
              </li>
              <li>
                - Either parties shall not be liable for any failure for any
                technical issues attributable to the either Parties because of
                which the transaction made by the user was not successful.
                Parties shall mutually resolve the issues pertaining to their
                respective breaches. Further, each party shall solely be liable
                to the user for wrongful acts/omissions attributable to them.
              </li>
              <li>
                - The user shall indemnify and hold Vuezen harmless against all
                damages, liabilities, costs, expenses, claims, suits and
                proceedings (including reasonable attorneys fee) that may be
                suffered by Vuezen as a consequence of (i) violation of these
                terms and conditions, of the terms of user agreement, privacy
                policy (subject to change) published on the platform, by user;
                (ii) violation of applicable laws by user; and (iii) any action
                or inaction resulting in willful misconduct or negligence on the
                part of the user.
              </li>
              <li>
                - All government levies like sales tax, goods and services
                taxes, tax deducted at source, any local tax, octroi etc.shall
                be payable by the user as applicable at the time of the
                respective offer.
              </li>
              <li>
                - This offer shall be subject to all applicable laws, rules and
                regulations which are in existence and which may be promulgated
                anytime by any statutory authority.
              </li>
              <li>
                - This offer is valid only in India. The minimum age of such a
                user shall be 18 years.
              </li>
              <li>
                - This document is an electronic record in terms of Information
                Technology Act, 2000, and the Rules thereunder as applicable and
                the amended provisions pertaining to electronic records in
                various statutes as amended by the Information Technology Act,
                2000. This electronic record is generated by a computer system
                and does not require any physical or digital signatures.
              </li>
              <li>
                - We reserve the right, at any time, without prior notice and
                without assigning any reason whatsoever, to
                add/alter/modify/change or vary these terms and conditions,
                website, mobile applications, our general terms and conditions
                of use, and/or the policies listed in this document, or to
                replace, wholly or in part, an offer by another offer, whether
                similar to this offer or not, or to extend or withdraw it
                altogether.
              </li>
              <li>
                - Customer's right to avail the benefits under the Offer shall
                continue until such time that Vuezen, at its sole discretion and
                without the obligation of a notice, terminates the offer. The
                Customer may terminate these at any time by uninstalling the
                Vuezen App. These Terms will automatically terminate if Customer
                fails substantially to comply with them. Upon termination by
                Customer, or by Vuezen due to Customer's breach of these terms,
                Customer may not be entitled to any outstanding benefits of the
                offer.
              </li>
              <li>
                - These terms and conditions must be read in conjunction with
                the other terms and conditions of the usage of the Vuezen App
                and/or Vuezen's website available at ⦁ https://wwww.vuezen.io
              </li>
            </ul>
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>5.DESCRIPTION OF SERVICE AND PRODUCTS</h2>
          <p>
            The Company provides an opportunity for You to purchase the Products
            from high end manufacturers and retailers. Upon placing order, the
            Company shall ship the Product to You and will be entitled to its
            payment for the Services. All Products and information displayed on
            the Website/s constitute an "invitation to offer". Your order for
            purchase constitutes your "offer" which shall be subject to the
            terms and conditions as detailed in this Agreement. The Company may
            accept or reject Your offer in its sole discretion which cannot be
            contested by You. The Company, to the best of its knowledge, has
            displayed or attempts to display on the Website/s as accurately as
            is possible, colours of the Products that is displayed on the
            Website/s. However, the colours visible to You is solely dependent
            on Your monitor. Hence, no guarantee is provided by the Company
            regarding Your visibility of the colours on the Website/s. The
            Company does not provide any warranty or guarantee that the Product
            descriptions are accurate, complete, reliable, current, or
            error-free. If a Product offered by the Website/s is not as
            described, Your sole remedy is to return it in unused, unsoiled and
            resale condition. The Company currently offers you the following:
          </p>
          <p>Eyewear through its website wwww.vuezen.io</p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>6. YOUR OBLIGATION AND COVENATS TOWARDS THE PRODUCTS</h2>
          <p>
            In addition to Your other covenants in this Agreement, by ordering
            Product/s on the Website/s You acknowledge and agree that:
          </p>
          <p>
            You have a written and valid prescription from a doctor regarding
            your prescription glasses or lenses and the information supplied to
            the Company will be accurate;
          </p>
          <p>
            You consent to the Company contacting your doctor to verify the
            authenticity of the prescription if required;
          </p>
          <p>
            That any non-delivery or wrong delivery of the Products by the
            Company due to error in the information provided by You, then, any
            re-delivery cost in addition to the initial cost will be billed to
            You;
          </p>
          <p>
            All information provided by You including your contact details, name
            and address, bank or credit card details are Yours and authentic and
            there is no misrepresentation or fraudulent act from Your end;
          </p>
          <p>
            That before placing an order You will check the Product description
            carefully. By placing an order for a Product You agree to be bound
            by the conditions of sale included in the item's description.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>7. INFORMATION REQUIRED FROM YOU</h2>
          <p>
            Upon Your acceptance of agreeing to be a member and avail services
            from our Website/s, we would request You certain basic information
            for registration. Once You provide us with the details, we would
            request You for additional information in order to provide You with
            the services. However, we will not request You for any personal
            information or identity disclosure. All information provided form
            You will be treated as private and confidential. The same is more
            fully detailed under clause in Privacy Policy and Security below. In
            compliance with this policy we disclose to our End-Users the usage
            of a third-party technology (UXCam) for data collection and comply
            will all applicable laws, rules and regulations, including screen
            recording of sessions within the scope of Vuezen Android app
            (Version 3.3.1 only). UXCam Inc. provides a software development kit
            which allows to record and analyse user behavior in mobile apps (the
            “Service(s)”). We agree that we will not provide any Sensitive Data
            to UXCam. UXCam shall use and maintain Customer Data only as set
            forth in this Agreement and the UXCam Privacy Policy available at
            www.uxcam.com/privacy, as may be updated from time to time.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>8. ORDER FOR AND SUPPLY OF PRODUCTS</h2>
          <p>
            You will have to submit Your Order for the purchase of the Product
            as detailed under the Website/s or you can e-mail us at
            support@Vuezen.io or contact us at 000000444.
          </p>
          <p>
            Once the order is submitted it an express intention to purchase the
            Product and the same may not be cancelled except as provided
            hereunder.
          </p>
          <p>
            Based on the information provided by You and subject to the
            Company’s verification of the same, the Orders will be accepted by
            the Company for processing.
          </p>
          <p>
            All orders will be processed once the Company receives the payment
            for the Product.
          </p>
          <p>
            You acknowledge that with respect to prescription glasses the
            Company reserves the right to verify the same with Your prescribing
            doctor as well as independent qualified optician. And the acceptance
            of the order by the Company is subject to the same.
          </p>
          <p>All orders will be confirmed via e-mail.</p>
          <p>
            The Company will use its best efforts to ensure that order placed by
            You is successfully processed subject to the availability of the
            Product/s. In the event the Product/s is sold out or unavailable,
            the Company will intimate You regarding the same and either refund
            Your money or provide you with an opportunity to purchase a
            different Product of the same value.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>9. PRICING AND PAYMENT</h2>
          <p>
            The prices for Product/s are described on the Website/s and are
            incorporated into these terms by reference. All prices are in Indian
            rupees. The prices, products and services are subject to change at
            the Company’s discretion. (b) All prices are inclusive of any tax
            that may be required to be remitted to tax authorities. (c) The
            Company will use its best efforts to ensure that the accuracy of the
            prices and price related information stated on the Website/s. The
            Company does not make any representation that the prices quoted on
            the Website/s will match the offers provided by stores. (d) In the
            event of any inadvertent mistake by the Company in quoting the
            price, the Company will notify You of the error before Your payment
            is processed. You will then have the choice to either accept the
            correct price or to cancel Your Order. (e) The Company accepts the
            following form of payments: i) Online payment via Credit Card, Debit
            Card, Net Banking and Paypal ii) Cash on Delivery on limited
            locations which is subject to our return / refunds policy; iii) Cash
            Deposit on our bank account. (f) You agree, understand, confirm and
            state that the card details provided by You to transact on the
            Website will be correct, accurate and is owned by You. In the event
            You use the card belonging to any third party, then, You confirm
            that you have been authorized to or expressly permitted by such
            third party to use the card for making payments. (g) The Company
            will not be liable for any credit card fraud. The liability for use
            of a card fraudulently will be on the User and the onus to 'prove
            otherwise' shall be exclusively on the User. (h) In addition to all
            other remedies available under law and equity and as detailed under
            this Agreement, the Company reserves the right to recover the cost
            of Product/s, collection charges, attorney’s charges etc., from an
            User using the Website/s fraudulently. Further, the Company reserves
            the right to initiate legal proceedings against such persons for
            fraudulent use of the Website/s and any other unlawful acts or acts
            or omissions in breach of these terms and conditions. (i) It is
            clarified that Vuezen does not charge any fee or charges for the
            payments. If any specific charges or fee is charged by the payment
            gateways, the same will be specifically communicated to You in
            course of the transaction.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>10. DELIVERY AND CANCELLATION</h2>
          <p>
            The Company expressly disclaims any guarantee of exactness as to the
            finish and appearance of the final Product/s as ordered by You based
            on the display on the Website/s. The quality of any Product/s,
            Services, information, or other material purchased or obtained by
            You through the Website/s may not meet your expectations. There may
            be alteration with respect to you Order. This will be intimated to
            you by the Company. If you do not agree with the same, the Company
            will provide you an opportunity to either receive a full refund or a
            voucher to be redeemed against the purchase of the alternative
            Product of the same value. (b) Title and risk of loss for all
            Product/s ordered by You shall pass on to You upon the Company’s
            shipment to the shipping carrier. (c) The Company will make the
            delivery on a ‘best effort’ basis after acceptance of Your order.
            Subject to events beyond the Company’s control, the Product/s will
            be shipped within 7 days of the acceptance of the order. (d) The
            Company will communicate the dispatch details to You and will ship
            the Product/s to the mailing address provided by You while placing
            the order. If you do not receive the Product/s within a reasonable
            period of time, You should immediately notify the Company. (e) You
            have an obligation to forthwith check the Product/s for accuracy
            upon receipt of the same. (f) The Company reserves the right to
            cancel an order in case the order request is not acceptable to the
            Company. Upon such cancellation, the Company will refund the money
            to You. Any such cancellation shall be at the sole discretion of the
            Company and You will have no right to contest the same. The reasons
            for cancellation could be due to non-availability of the Product/s,
            in accuracy in Product or pricing information or due to reasons of
            any fraud or wrong usage of payment mechanism adopted by You. Any
            cancellation will be intimated to You by the Company. (g) In the
            event You desire to cancel any order, then, such cancellation must
            be done prior to the ’s dispatch of the Product/s to you. Once
            dispatched, the Company will not accept any cancellation request
            from Your end.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>11. LINKS TO THIRD PARTY SITES</h2>
          <p>
            As part of availing the Services, You as a member will provide us
            Your personal information either to retrieve or collect data or
            information from third party websites. Such third party websites may
            be maintained by such financial institutions with whom You have an
            account, bank with or have created certain liabilities. The Company
            does not and cannot assume any responsibility or accuracy for such
            information or data maintained by such third party either in terms
            of updation, accuracy, deletion, non-delivery or failure to store
            data, communications, etc. The Website may provide, or third parties
            may provide, or the Website may contain links to other World Wide
            Web sites or resources. The responsibility for the operation and
            content of those websites shall rest solely with the organization
            identified as controlling the third party website and will be
            governed by separate terms and conditions. Links are provided for
            convenience and inclusion of any link does not imply endorsement in
            any way of the site to which it links. Because the Company has no
            control over such sites and resources, You acknowledge and agree
            that the Company is not responsible for the availability of such
            external sites or resources, and does not endorse and is not
            responsible or liable for any content, advertising, products, or
            other materials on or available from such sites or resources. You
            further acknowledge and agree that the Company shall not be
            responsible or liable, directly or indirectly, for any damage or
            loss caused or alleged to be caused by or in connection with use of
            or reliance on any such content, goods or services available on or
            through any such site or resource.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>12. REGISTRATION AND USE</h2>
          <p>
            You agree and understand that You are responsible for maintaining
            the confidentiality of all information provided to the Company while
            registering Yourself, which includes Your login ID, e-mail address
            and the passwords for the same. You are fully responsible for all
            activities that occur under Your e mail address password or account
            and You shall ensure that You exit from Your account at the end of
            each session. The Company will send all correspondences, notices and
            any other communication to the e-mail address furnished by You. In
            case of any change in the said e-mail address, it is Your duty to
            update or change the same. The Company shall maintain utmost secrecy
            and use all the security measures to ensure that the information is
            not misused by any third party. In the event of Your becoming aware
            of any unauthorized or misuse of the information provided by You to
            the Company, You are requested to forthwith contact the Company at
            Luxelace Luxury Private Limited, A-63 Sector 4, Noida, Uttar Pradesh
            201301. The Company cannot and will not be liable for any loss or
            damage arising from Your failure to comply with this Section.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>13. LEGAL USES</h2>
          <p>
            Further, You agree and understand that Your right to access and use
            the Services offered on this Website is personal to You and is not
            transferable by You to any other person or entity. You understand
            that You are authorized to access and use the services only for
            legal and lawful purposes. You further undertake and state that by
            using the services You are in no way impersonating or
            misrepresenting any person or entity. All services availed are for
            Yourself only. In the event You are representing individual/s,
            company/ies, third parties or any entities, You undertake and state
            that You are authorized to represent such individual/s, company/ies,
            third parties or any entities. You shall be solely responsible for
            the consequences arising out of such acts and the Company shall not
            be held responsible or liable in anyway to any person or entity. Any
            changes in Your registration information must be duly updated by
            You. Your access and use of this Website may be interrupted from
            time to time for any of the several reasons, including, without
            limitation, the malfunction of equipment, periodic updating,
            maintenance or repair of the Website or other actions that the
            Website, in its sole discretion, may elect to take. We at the
            Company utilize our best efforts to provide the Services without any
            interruptions or hindrance, however, we do not warrant that the
            function, operation, security or accessibility of the Website will
            be uninterrupted or error-free, that defects will be corrected, or
            that this Website or the server that makes it available will be free
            of viruses or other harmful elements. As a user of the Website, You
            agree that Your access will be subject to these terms and conditions
            and that access is undertaken at Your own risk. We shall not be
            liable for damages of any kind related to Your use of or inability
            to access the Website
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>14. STORAGE, DELETION OR TRANSPORT OF DATA</h2>
          <p>
            The Company states that the data provided by You shall belong solely
            and exclusively to You. As such, You are permitted to remove or
            delete the data, so provided, either in full or any portion, at any
            point in time as You desire. The Company requests You to notify the
            Company of such removal or deletion. In the event, You desire the
            Company to remove or delete all or any portion of the data belonging
            to You, then, the same needs to be provided in writing to the
            Company. Upon receipt of such written request, the Company will do
            the needful forthwith and notify You of the same. The Company will
            not retain any copies of such data on its server or in any other
            place. In this regard, the Company warrants that it cannot access
            such deleted material at any point in time. Any contact, information
            or access that the Company had towards such data or material or
            accounts will cease forthwith. However, certain portions of Your
            data, which the Company had maintained on its servers may remain
            either in backups or in transaction logs. These are maintained only
            for the specific purpose of backup or to provide Services to You in
            the event of any malfunction or damage to our server in order to
            ensure continuity of our service without disruption.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>15. COMMUNICATION</h2>
          <p>
            The Company may send you communication, notices or alerts from time
            to time. These alerts and communication will be sent automatically
            by the Company to You. Please be informed that you have agreed to
            receive any type of communication including but not limited to
            emails, SMS, phone calls or any other mode of communication from us
            that is transactional, promotional & informational in nature. In
            case You have suppressed the receipt or disabled or marked alerts or
            communication in general to be junked, the Company recommends You to
            revise the same and activate the receipt of alerts to Your proper
            destination. As such any communication from our end will be related
            to the Services and not any marketing or spam mails. Changes to Your
            email address will apply to all of Your alerts. Any e-mail which is
            sent by the Company or through any of the websites mentioned above,
            its contents and attachments, if any, are intended solely for the
            attention of the addressee/s and may also be privileged. If You are
            not the addressee You may not copy, forward, disclose any part of
            any message received or its attachments and if You receive a message
            in error, please delete the said message from Your system and notify
            us immediately. You agree and acknowledge that internet
            communications cannot be guaranteed to be secure or error free. Any
            information sent via internet could be intercepted, corrupted, lost
            or contain viruses. The Company and the Website therefore does not
            accept responsibility for any errors or omissions in messages
            received by You which may arise as a result of internet
            transmission.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>16. RIGHTS GRANTED BY YOU</h2>
          <p>
            As the provision of Services includes You providing us with
            information, data, passwords, usernames, personal identification
            numbers and other materials and contents, suggestions, ideas,
            feedback, etc., You are hereby expressly granting us the license and
            right to utilize the same for and on Your behalf in order to provide
            the Services. The Company may or will use such information with the
            sole purpose for providing You the required Services and not for any
            other purpose. As such, You hereby warrant and represent that You
            are duly authorized to submit or represent the third party on behalf
            of whom You are providing these information to the Company. Further,
            You acknowledge and agree that these materials, suggestions,
            feedback and information can be utilized without any obligation or
            restriction on the Company in terms of payment of fee or any other
            limitations for marketing, promoting, advertising or other purposes.
            By using the Service, You expressly authorize the Company to access
            Your accounts maintained by identified third parties, on Your behalf
            as Your agent. When You use the specified feature of another
            additional account of the Service, You will be directly connected to
            the website for the third party You have identified. The Company
            will submit information including usernames and passwords that You
            provide to log you into the site. You hereby authorize and permit
            the Company to use information submitted by You to the Service (such
            as account passwords and users names) to accomplish the foregoing
            and to configure the Service so that it is compatible with the third
            party sites for which You submit Your information.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>17. YOUR POSTINGS ON WEBSITE</h2>
          <p>
            We, as part of our Service, encourage and permit You to post Your
            messages or content on any publicly available forums, blogs and
            other locations on the Website. By using or posting messages or data
            or any other information on such forums, blogs and other public
            locations, You expressly agree that You and only You, are
            responsible for all the matters contained in such content. You
            further, represent and warrant to us that You have all the necessary
            rights to post such messages or information or content and grant us
            a perpetual, worldwide, royalty free, non-exclusive, transferable
            and sub licensable right to use, reproduce, distribute, display,
            modify, amend, perform, etc of such content or information to
            promote, modify or redistribute this Website, including preparation
            of any derivative works thereof, in any form and through any medium
            without any restrictions thereof. You expressly agree that all the
            rights granted under this paragraph will also be available to each
            and every user of this Website. Further, if You intend to use a
            forum, a blog or any other feature available on this Website, then,
            You should make an independent and informed choice about submitting
            Your personal identifiable information. All personally identifiable
            information submitting on such forums, blogs or community features
            can be read, collected or used by any third party. There is a danger
            of such information being misused or misappropriated. We do not have
            control over such actions and we are not responsible or liable for
            the personally identifiable information that You as a user have
            chosen to submit on a public platform. In case of any violation of
            this condition, then, the Company reserves the right to forthwith
            stop your participation on such public forums.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>18. INTELLECTUAL PROPERTY</h2>
          <p>
            You acknowledge and agree that this Website and any necessary
            software used in connection with the Website contain proprietary and
            confidential information that is protected by applicable
            intellectual property and other laws. You further acknowledge and
            agree that any content or software on this Website, including its
            “look and feel” (e.g., text, graphics, images, logos and button
            icons), photographs, editorial content, notices, software (including
            html-based computer programs) and other material is protected by
            national and international laws relating to copyrights, trademarks,
            service marks, patents or other proprietary rights. Except as
            expressly authorized by the Company You agree not to modify, rent,
            lease, loan, sell, distribute or create derivative works based on
            this Website, the Services offered thereto or any software thereto,
            in whole or in part. You acknowledge that the entire Website and its
            contents including the software is owned or duly licensed to the
            Company and are protected by the Copyright laws in India and under
            international treaty provisions. All trademarks, service marks, and
            logos used and displayed on this Website are registered to and/or
            owned by their respective owners. Nothing on this Company Website
            should be construed as granting, by implication, estoppel, or
            otherwise, any license or right to use any of the trademarks,
            service marks and logos displayed on the Website, without the prior
            written consent and permission of the Company or the respective
            owners. You may download or print a copy of information provided on
            this Website for Your personal, internal and non-commercial use
            only. Any distribution, reprint or electronic reproduction of any
            content from this Website in whole or in part for any other purpose
            is expressly and explicitly prohibited without our prior written
            consent.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>19. PROHIBITED ACTIVITIES</h2>
          <p>
            You agree NOT to do to the following: (a) upload, post, email,
            transmit or otherwise make available any content that is unlawful,
            harmful, threatening, abusive, harassing, tortuous, defamatory,
            vulgar, obscene, libelous, invasive of another's privacy, hateful,
            or racially, ethnically or otherwise objectionable; (b) impersonate
            any person or entity, including, but not limited to, officials,
            directors, employees, agents, authorized representatives, forum
            leaders, guides or hosts, or falsely state or otherwise misrepresent
            any information or accounts; (c) forge headers or otherwise
            manipulate identifiers in order to disguise the origin of any
            content or material transmitted or provided through the Site; (d)
            Collect or store personal data about other users; (e) Interfere with
            or disrupt the Website or servers or networks connected to the
            Website, or disobey any requirements, procedures, policies or
            regulations of networks connected to the Website; (f) Intentionally
            or unintentionally violate any applicable local, state, national or
            international law; (g) Upload, post, email, transmit or otherwise
            make available any material that contains software viruses or any
            other computer code, files or programs designed to interrupt,
            destroy or limit the functionality of any computer software or
            hardware or telecommunications equipment; (h) Upload, post, email,
            transmit or otherwise make available any unsolicited or unauthorized
            advertising, promotional materials, "junk mail," "spam," "chain
            letters," "pyramid schemes," or any other form of solicitation,
            except in those specific areas that may be designated for such
            purpose of posting such mails or messages by the Company; (i) Use
            any robot, spider, scraper, deep link or other similar automated
            data gathering or extraction tools, program, algorithm or
            methodology to access, acquire, copy or monitor this Website, either
            in whole or part; (j) Use or attempt to use any engine, software,
            tool, agent, or other device or mechanism (including without
            limitation browsers, spiders, robots, avatars or intelligent agents)
            to navigate or search this Website, other than the search engines
            and search agents available through the Service and other than
            generally available third-party web browsers (such as Microsoft
            Explorer); (k) Attempt to decipher, decompile, disassemble, or
            reverse-engineer any of the software comprising or in any way making
            up a part of this Website or the Service. (l) post or transmit any
            message, data, image or program that would violate the property
            rights of others, including unauthorized copyrighted text, images or
            programs, trade secrets or other confidential proprietary
            information, and trademarks or service marks used in an infringing
            fashion. (m) You may not interfere with other Users’ use of the
            Service, including, without limitation, disrupting the normal flow
            of dialogue in an interactive area of this Website, deleting or
            revising any content posted by another person or entity, or taking
            any action that imposes a disproportionate burden on the Service
            infrastructure or that negatively affects the availability of the
            Service to others. You agree that any employment or other
            relationship You form or attempt to form with an employer, employee,
            or contractor whom You contact through areas of this Website that
            may be designated for that purpose is between You and that employer,
            employee, or contractor alone, and not with us.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>20. RETURN, REFUND OR EXCHANGE POLICY</h2>
          <p>
            The Company provides You a return, refund or exchange opportunity on
            your purchase through the website, in the event you are unhappy
            you’re your purchase provided You meet with the following
            conditions: (a) The request for return, exchange or refund should be
            raised within 14 (fourteen) days of the receipt of the products from
            our Website; (b) The price tag and any other identification tag, the
            invoice and the original packing must be intact and sent back; (c)
            The product should not have been used or should not have any dirt or
            scratches or tear or in short should not be rendered unsellable; (d)
            You need to mention your order number, the date of order and your
            date of receipt; (e) Ensure that the return package is appropriately
            sealed and sent to the Company as any damage in transit will
            continue to be your responsibility and this policy will cease to be
            applicable; (f) The Company has a dedicated team which will check
            the returned products and their decision of your request will be
            final to accept or reject; (g) In case your request is accepted by
            our team, we would refund you an amount upto Rs. 100 towards the
            shipping cost or provide you with a voucher; (h) To request for a
            return, refund or exchange, please contact our customer care at ⦁
            1800-202-4444 or mail us at ⦁ support@Vuezen.com. .and we will get
            in touch with you. Following are the additional requirements for
            specific products: (a) For boxes in which the product is stored:
            Ensure all components are intact included any beads, threads, glass
            motifs, zips, buckles, etc. The boxes must be unwashed and there
            should no stains. (b) For lenses: Ensure no scratches are made. Lens
            should remain intact and must be returned with all the original box,
            instructions, guarantee and any other extras or complimentary
            offers, if any. (c) For glasses: Ensure no scratches are made. The
            frames should not be bent or twisted. All screws and any embedment
            should remain intact and must be returned with all the original box,
            instructions, guarantee and any other extras or complimentary
            offers, if any. The refund, return or exchange process will be
            initiated only after we have received the product/s in the condition
            as mentioned above. As stated You could either get a refund of cash
            or exchange it for a voucher. If this is not applicable, You could
            exchange the purchase product for a different product of the same
            value or a higher value. No difference will be paid in case the
            exchange is made for a product of a lower value. The option will be
            communicated either via an e-mail provided by You to us or through a
            contact number which You have notified us. The Company is not
            responsible for any incorrect or mis-leading contact details. You
            will have a period of 7 (seven) days to confirm Your decision to us.
            In the event we do not receive any communication from You then your
            opportunity to obtain a refund, return or exchange will lapse.
            Refunds are processed in 30 (thirty) working days but in case of
            payments by Cheque or Demand Draft, additional days may be required
            to dispatch and for the funds to be credited to your account. Apart
            from these, in the case the original manufacturers/producer/reseller
            provide any specific warranty, then, those will be applicable
            subject to Your compliance with the warranty terms mentioned
            therein. With respect to the warranty offered by the original
            manufacturer /producer/reseller, the Company would not be
            responsible or liable for the same. Your claims will have to be
            raised with the original manufacturer /producer/reseller. If
            feasible, the Company may provide reasonable assistance in this
            regard. This policy is only for customers in India and we won’t be
            able to provide exchange, returns or refunds to our international
            customers due to prohibitive shipping costs.
          </p>
          <p>
            Notwithstanding the above, on cash on delivery orders whether online
            or through stores, refunds will not be issued.
          </p>
          <p>
            Customers may request to exchange a purchased item for another
            product. In such cases, if the exchange product selected by the
            Customer is priced lower than the original item, any price
            difference will not be refunded.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>21. SECURITY AND PRIVACY</h2>
          <p>
            The Company knows that You care how information about You is used
            and shared, and we appreciate Your trust that we will do so
            carefully and sensibly. We let You retain as much control as
            possible over Your personal information. However, You may not visit
            and use our site at anytime without telling us who You are or
            revealing the required information about Yourself. To the Company,
            our most important asset is our relationship with You. We are
            committed to maintaining the confidentiality, integrity and security
            of any personal information about our users. We are proud of our
            privacy practices and the strength of our site security and want you
            to know how we protect Your information and use it to provide to You
            the services. This notice describes our privacy policy. By visiting
            this Website, You are accepting the practices described in this
            Privacy Policy. (a) Information You Give Us: We receive any
            information You enter on our Website or give us in any other way.
            However, we do not store any personal sensitive information on our
            server. They remain with You on Your system. You can choose not to
            provide certain information, but then You might not be able to take
            advantage of many of our features. We use the information that You
            Provide for such purposes as responding to your requests,
            customizing future commercial transactions, improving our data base,
            and communicating with You and utilising/exploiting/disclosing,
            without prejudice to any of Your other rights, the same for any
            other, whether commercial or non-commercial purpose which the
            Company in its sole discretion considers necessary for its business
            purposes or otherwise. You can add or update certain information.
            When You update information, we usually keep a copy of the prior
            version for our records. (b) Automatic Information: We receive and
            store certain types of information whenever You interact with us.
            Our server logs Your activities for various diagnostic and
            analytical purposes. However, other than the IP address of Your
            machine from where You are accessing the Service, there are no other
            personal information maintained by the Company in the logs. (c)
            E-mail Communications: To help us make e-mails more useful and
            interesting, we may request to receive a confirmation when You open
            e-mail from Your end if Your computer supports such capabilities.
            (d) Sharing of Information Received by the Company: You can tell
            when another business is involved in Your transactions, and we
            share, use or, disclose customer information related to those
            transactions with that business. (e) Business Transfers: As we
            continue to develop our business, we might be acquired completely or
            merge with any other Company. In such transactions, customer
            information generally is one of the transferred business assets. In
            such a case, we will intimate to You of the same and ensure the
            protection of Your information as per these policies and guidelines.
            (f) Protection of the Company and Others: We release account and
            other personal information when we believe release is appropriate to
            comply with law; enforce or apply our Terms and Conditions and other
            agreements; or protect the rights, property, or safety of Company,
            our users, or others. This includes exchanging information with
            other companies and organizations for fraud protection and other
            similar matters.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>22. SECURITY OF INFORMATION</h2>
          <p>
            We work to protect the security of your information during
            transmission by using Secure Sockets Layer (SSL) software, which
            encrypts information You input. We constantly re-evaluate our
            privacy and security policies and adapt them as necessary to deal
            with new challenges. We do not and will not sell or rent Your
            personal information to anyone, for any reason, at any time, unless
            it is in (i) in response to a valid legal request by a law
            enforcement officer or government agency or (ii) when You have
            explicitly or implicitly given Your consent, or (iii).utilize the
            same for some statistical or other representation without disclosing
            personal data. We only reveal those numbers of Your account as
            required to enable us to access and provide You the required
            services relating to Your accounts. We make every effort to allow
            You to retain the anonymity of Your personal identity and You are
            free to choose a Login ID email address and password that keeps Your
            personal identity anonymous. Access to Your Registration Information
            and Your personal financial data is strictly restricted to those of
            our Company employees and contractors, strictly on a need to know
            basis, in order to operate, develop or improve the Service. These
            employees or contractors may be subject to discipline, including
            termination and criminal prosecution, if they fail to meet these
            obligations. With the exception of a Login ID in the form of an
            email address, which may be provided on an anonymous basis, and Your
            Third Party Account Information, which is required for providing the
            services, the Company does not require any information from You that
            might constitute personally identifiable information. It is
            important for You to protect against unauthorized access to Your
            password and to Your computer. Be sure to sign off when finished
            using a shared computer. As described in this Agreement and with
            Your consent, the Company will from time to time connect
            electronically to Your online bank, credit card and other online
            financial accounts to process Your Order. Conditions of Use,
            Notices, and Revisions: If You choose to visit this Website, Your
            visit and any dispute over privacy is subject to this Agreement,
            including limitations on damages, arbitration of disputes, and
            application of the law of the Republic of India. If You have any
            concern about privacy at this Website, please send us a thorough
            description to Luxelace Luxury Private Limited, A-63, Sector-4
            Noida, Uttar Pradesh 201 and we will try to resolve it. Our business
            changes constantly. This Notice and the Terms of Membership will
            change also, and use of information that we gather now is subject to
            the Privacy Policy in effect at the time of use. We may e-mail
            periodic reminders of our notices and conditions, unless You have
            instructed us not to, but You should check our Website frequently to
            see recent changes.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>23. DISCLAIMER</h2>
          <p>
            THE CONTENT AND ALL SERVICES ASSOCIATED WITH THIS WEBSITE OR
            PROVIDED THROUGH THE SERVICE ARE PROVIDED TO YOU ON AN “AS-IS” AND
            “AS AVAILABLE” BASIS. THE COMPANY MAKES NO REPRESENTATIONS OR
            WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE CONTENT OR
            OPERATION OF THIS WEBSITE OR OF THE SERVICE. YOU EXPRESSLY AGREE
            THAT YOUR USE OF THE SERVICE AND PURCHASE OF THE PRODUCTS IS AT YOUR
            SOLE RISK. THE COMPANY MAKES NO REPRESENTATIONS, WARRANTIES OR
            GUARANTEES, EXPRESS OR IMPLIED, REGARDING (i) THE ACCURACY,
            RELIABILITY OR COMPLETENESS OF THE CONTENT ON THIS WEBSITE OR (ii)
            OF THE SERVICE AND PRODUCTS AND EXPRESSLY DISCLAIMS ANY WARRANTIES
            OF NON-INFRINGEMENT OR FITNESS FOR A PARTICULAR PURPOSE. THE COMPANY
            ENGAGES AND EMPLOY THE BEST METHODS TO SAFEGUARD AND PROTECT AGAINST
            VIRUSES, INFECTION., ETC, HOWEVER, DESPITE SUCH BEST EFFORTS, THE
            COMPANY MAKES NO REPRESENTATION, WARRANTY OR GUARANTEE THAT THE
            CONTENT THAT MAY BE AVAILABLE THROUGH THE SERVICE IS FREE OF
            INFECTION FROM ANY VIRUSES OR OTHER CODE OR COMPUTER PROGRAMMING
            ROUTINES THAT CONTAIN CONTAMINATING OR DESTRUCTIVE PROPERTIES OR
            THAT ARE INTENDED TO DAMAGE, SURREPTITOUSLY INTERCEPT OR EXPROPRIATE
            ANY SYSTEM, DATA OR PERSONAL INFORMATION.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>24. LIMITATION OF LIABILITY</h2>
          <p>
            THE COMPANY SHALL IN NO EVENT BE RESPONSIBLE OR LIABLE TO YOU OR TO
            ANY THIRD PARTY, WHETHER IN CONTRACT, WARRANTY, TORT (INCLUDING
            NEGLIGENCE) OR OTHERWISE, FOR ANY INDIRECT, SPECIAL, INCIDENTAL,
            CONSEQUENTIAL, EXEMPLARY, LIQUIDATED OR PUNITIVE DAMAGES, INCLUDING
            BUT NOT LIMITED TO LOSS OF PROFIT, REVENUE OR BUSINESS, BUSINESS
            INTERRUPTION, LOSS OF PROGRAMS OR INFORMATION, OR LOSS OF SAVINGS,
            OR ANY OTHER DAMAGES ARISING - IN ANY WAY, SHAPE OR FORM - OUT OF
            THE AVAILABILITY, USE, RELIANCE ON, OR INABILITY TO UTILIZE THE
            SERVICE ARISING IN WHOLE OR IN PART FROM YOUR ACCESS TO THIS
            WEBSITE, YOUR USE OF THE SERVICE, YOUR PURCHASE OF PRODUCTS THROUGH
            THE WEBSITE OR THIS AGREEMENT, EVEN IF THE COMPANY HAS BEEN ADVISED
            OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>25. INDEMNITY BY YOU</h2>
          <p>
            You shall defend, indemnify and hold harmless the Company and its
            officers, directors, shareholders, and employees, from and against
            all loss, damages, claims and expenses, including but not limited to
            attorneys fees, in whole or in part arising out of or attributable
            to any breach of this Agreement by You, any misrepresentation or
            misuse of the Service offered to You or any negligent or
            unreasonable or inappropriate use of the Website or the Services.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>26. TERMINATION</h2>
          <p>
            This Agreement to be applicable and shall be binding on the parties,
            i.e., You and the Company, unless terminated as specified below: (a)
            by You, by providing a written notice of at least 3 (three )
            business days; (b) closure of Your account by the Company or You for
            any reason immediately; (c) The Company may terminate this Agreement
            and close Your account if it comes to the knowledge of the Company
            that You have breached any of these terms and conditions, whether
            intentionally or by implication; (d) The Company may terminate the
            Agreement, it is so required to be one by an express direction of
            law. Please use the following address for all communication: A-63,
            Sector 4, Noida, Uttar Pradesh 201301. The Company hereby expressly
            states that this Service (including, without limitation, the
            underlying network, system, software, servers, various directories
            and listings, various message and news and bulletin boards, blogs,
            tools, information and databases) is intended for End Users who are
            legally permitted to enter into a contract. This Service is not
            intended for the use of minors or people who are not permitted to
            enter into a valid and binding contract. In the event if it comes to
            the attention of the Company, from authentic and valid resources,
            that a particular End User does not meet this criteria, then, the
            Company will forthwith close the account of the said End User and
            will delete all information and content which is relating to that
            End User without any obligation or liability towards such End User
            from the Company’s records.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>27. JURISDICTION</h2>
          <p>
            The Company controls and operates this Website/s from its registered
            office in New Delhi, India, and makes no representation that these
            materials are appropriate or available for use in other locations.
            If You use this Website/s from other locations, You are responsible
            for compliance with applicable local laws. This Agreement shall be
            treated as though it were executed and performed in New Delhi, India
            and shall be governed by and construed in accordance with the local
            domestic laws of India (without regard to conflict of law
            principles). All legal proceedings arising out of or in connection
            with this Agreement shall be brought solely in New Delhi, India. All
            disputes that may arise shall be resolved in accordance with rules
            specified under the Indian Arbitration and Conciliation Act, 1996
            and venue for arbitration shall be New Delhi. The courts in New
            Delhi shall have the sole jurisdiction regarding the subject matter
            of this Agreement.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>28. MISCELLANEOUS</h2>
          <p>
            (a) The language in this Agreement shall be interpreted as to its
            fair meaning and not strictly for or against either party.{" "}
          </p>
          <p>
            (b) Should any part of this Agreement be held invalid or
            unenforceable, that portion shall be construed consistent with
            applicable law and the remaining portions shall remain in full force
            and effect without being impaired or invalidated in any way.
          </p>
          <p>
            (c) To the extent that anything in or associated with the Website is
            in conflict or inconsistent with this Agreement, this Agreement
            shall take precedence.{" "}
          </p>
          <p>
            (d) Failure of the Company to enforce any provision of this
            Agreement shall not be deemed a waiver of such provision nor of the
            right to enforce such provision.{" "}
          </p>
          <p>
            (e) This Agreement may only be amended by either the same electronic
            means as were used to enter into this Agreement or in a writing that
            specifically refers to this Agreement, executed by both parties
            hereto.{" "}
          </p>
          <p>
            (f) Vuezen Solutions Pvt. Ltd. sells products under various brands &
            sub-brands (including its own brands such as John Jacobs and
            others).{" "}
          </p>
          <p>
            (g) In case of any issue, you may reach out to our grievance officer
            Mail on @vuezen.io contact no. 12344322133.
          </p>
        </TermsContentSection>

        <TermsContentSection>
          <h2>29. TERMS AND CONDITIONS FOR EYE TESTING APPOINTMENT</h2>
          <p>
            - Vuezen offers a facility for the booking of eye testing
            appointments. You may make appointments for eye testing by
            visiting 0. https://www.Vuezen.com/HTO/ or dialling 1234556 By
            making an appointment, you are confirming that: (i) You consent to
            an executive engaged by us to visit and be present at the premises
            designated by you for the purpose of eye testing and further, to pay
            any charges associated with such eye testing; (ii) You will be
            available to attend in person at the designated premises at the
            chosen date and time; (iii) The information provided by you to us
            while making the appointment and also the feedback and inputs
            provided by you to the executive is true and accurate; (iv) You
            consent to us contacting you in connection with the eye testing
            appointment.
          </p>
          <p>
            - The calls made by you for the purpose of booking the eye testing
            appointment may be recorded for quality checking and feedback
            purposes.
          </p>
          <p>
            - Please note that our executive will not undertake any eye
            examination and recommend you to an Ophthalmologist in case of the
            following: (i) If the executive is not able to achieve 6/6 Vision
            (best-corrected visual acuity) in any eye; (ii) If the executive
            sees any abnormality in cornea or lid (external eye structures) like
            scar, excessive redness, discharge, watering which are indicative of
            infection/injury; (iii) If your blood sugar or hypertension is not
            controlled; (iv) If your vision is not improving with pin hole test;
            (v) If the executive is unable to get a reading with spot vision and
            also your previous prescription or power of glasses is not
            available; (vi) Children below the age of 12 years; (vi) Cases of
            glaucoma.
          </p>
          <p>
            - The refraction done and/ or a prescription given is not a complete
            eye-check up and we do not prescribe any medicine/ eye drops.. This
            check-up will not detect any ailments related to the eyes. The
            executive shall undertake an elementary eye check which shall be
            limited to the following: (i) External examination of the eye with
            torch light; (ii) Mobility of the eyes in different gaze; (iii) Near
            point of convergence assessment; (iv) Assessment of vision; (v)
            Refractive error assessment; (vi) Providing prescription; (vii)
            Suggesting spectacle lens and frames as per your requirement.
          </p>
          <p>
            - You may provide us with preferred time slots while making the
            appointment. The executive will use reasonable endeavours to keep
            any appointment you make with us for eye testing but we cannot
            guarantee that the executive will arrive on time in each case. If
            the executive is delayed, he or she will try to contact you a
            reasonable time in advance to let you know of any expected delay.
            From time to time, due to unavoidable reasons, we may also have to
            re-schedule an appointment. In such an event, we will try to
            re-schedule another appointment as soon as reasonably possible. We
            will not be responsible to you for any delay in keeping appointments
            or if we have to re-schedule an appointment. We will not be
            responsible if we are impaired or stopped from carrying out the eye
            testing by you for any reason whatsoever or are otherwise unable to
            provide carry out the eye testing as a result of any event that is
            outside our reasonable control
          </p>
          <p>
            - You hereby authorise the executive to enter the designated
            premises (provided by you at the time of making the appointment) for
            the purpose of conducting the eye test. If the designated premises
            are not reasonably accessible to the executive, you will have the
            right to designate an alternate premise where the eye test may be
            conducted. We reserve the right to cancel any eye testing
            appointments which are not reasonably accessible to the executive.
          </p>
          <p>
            - You agree to provide our executive with a safe working
            environment, working space, electrical power and any other
            facilities required for the purpose of conducting the eye test. You
            acknowledge that the executive may be an independent contractor or
            an employee. All our executives are certified Optometrists or
            Refractionists. You further acknowledge that we will not have any
            liability or claims that arise out of the actions of the executive.
            The results of the eye tests are based on the input provided by you
            and is subject to acceptable variance limits.
          </p>
          <p>
            - In no event shall we be liable for damages of any kind, including,
            without limitation, any direct, special, indirect, punitive,
            incidental or consequential damages including, without limitation,
            any loss or damages in the nature of, or relating to, lost business,
            medical injury, personal injury, wrongful death, improper diagnosis,
            inaccurate information, improper treatment or any other loss
            incurred in connection with you availing the eye testing
            appointment. The foregoing limitation shall apply even if we knew of
            or ought to have known of the possibility of such damages.
          </p>
        </TermsContentSection>
      </Container>
    </>
  );
};

export default TermsContent;
